import {Model} from 'vue-api-query'

Model.$http = window.axios;

export default class Crudable extends Model {
    constructor() {
        let className = [].shift.apply(arguments);
        if(typeof className === 'string'){
            super(...arguments);
            this.resource = () => className;
        } else {
            super(...arguments);
        }
    }

    baseURL() {
        return typeof window.Urlex !== 'undefined' && typeof window.Urlex.baseUrl ? window.Urlex.baseUrl + 'api/crudables' : '';
    }

    request(config) {
        return this.$http.request(config)
    }

    parameterNames() {
        return {
            include: 'include',
            filter: 'filter',
            sort: 'sort',
            fields: 'fields',
            append: 'append',
            page: 'page[number]',
            limit: 'page[size]'
        }
    }
}